var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-dropdown',{attrs:{"options":_vm.mappedExtraProducts,"value":_vm.extraProductId},on:{"change":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }